import React from 'react';
import styled from 'styled-components';
import Alert from '../../atoms/Alert';
import { type AlertProps } from '../../atoms/Alert/Alert';

const StyledAlert = styled(Alert)`
  position: relative;
  border-radius: 0;
  text-align: center;
  transition: all 500ms ease-out;
`;

const AlertBanner = (props: AlertProps) => <StyledAlert {...props} />;

export default AlertBanner;
